import { render, staticRenderFns } from "./Zapier.vue?vue&type=template&id=5a56c84a&scoped=true&"
import script from "./Zapier.vue?vue&type=script&lang=js&"
export * from "./Zapier.vue?vue&type=script&lang=js&"
import style0 from "./Zapier.vue?vue&type=style&index=0&id=5a56c84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56c84a",
  null
  
)

export default component.exports